import { Component, Input, AfterViewInit, ViewChild, ElementRef } from '@angular/core';

import { IRules } from 'rev-shared/ui/css/CssRules.Contract';
import { IVbrickPlayerConfig } from '@vbrick/vbrick-player';
import { WebcastModel } from 'rev-portal/scheduledEvents/webcast/model/WebcastModel';

import styles from './VbWebcastVodPreview.Component.module.less';

@Component({
	selector: 'vb-webcast-vod-preview',
	templateUrl: './VbWebcastVodPreview.Component.html',
	standalone: false
})
export class VbWebcastVodPreview implements AfterViewInit {
	@Input() public webcast: WebcastModel;
	@Input() public height: number;
	@Input() public width: number;
	@Input() public showThumbnailOnly: boolean;

	public readonly styles = styles;
	public styleOverrides: IRules;
	public playerLabelWidth: number;
	public showLabel: boolean = true;
	public playerConfig: IVbrickPlayerConfig = {
		playerControls: {
			overlayControls: true,
			overlaySeekControls: false,
			overlayPlayControlOnStop: true,
			playControls: false,
			cc: false,
			dualLayoutControl: false,
			settings: false,
			fullscreen: false
		},
		disableHotkeys: true
	};
	@ViewChild('playerLabel')
	public playerLabel: ElementRef;

	public ngAfterViewInit(): void {
		if (!this.showThumbnailOnly) {
			this.playerLabelWidth = this.playerLabel.nativeElement.offsetWidth;
		}
	}

	public onPlayerPlay(): void {
		this.showLabel = false;
	}

	public onPlayerPlaybackEnded(): void {
		this.showLabel = true;
	}
}
